<template>
    <div
        class="map-tab mg-scrollbar"
        :class="{
            'show-collapse': showCollapse,
            'show-business': !isMobile,
            collapsed: collapsed
        }"
        @click="replace && $emit('update:replace', false)"
        @mouseenter="replace && $emit('update:replace', false)"
    >
        <div class="tab-collapse" @click="collapsed = !collapsed">
            <i class="iconfont icon-more_arrow"></i>
        </div>
        <div
            class="tab-header"
            :class="{ single: tabs.length === 1 }"
            v-show="!showDetail"
        >
            <span
                v-for="tab in tabs"
                :key="tab.type"
                class="item"
                :class="[{ active: activeType === tab.type }, tab.type]"
                @click="activeType = tab.type"
            >
                <i class="iconfont" :class="iconMap[tab.type]"></i>
                {{ tab.label }}
            </span>
        </div>
        <div class="tab-body" v-show="!showDetail">
            <div
                v-for="tab in tabs"
                :key="tab.type"
                class="tab-content"
                :class="[{ 'more-panel': !!tab.moreLink }, tab.type]"
                v-show="activeType === tab.type"
            >
                <template v-if="tab.type === 'house'">
                    <ul v-if="tab.data" class="list">
                        <li
                            v-for="item in tab.data.slice(0, houseLimit)"
                            :key="item.id"
                            class="item"
                            :class="{
                                active:
                                    itemActiveKey ===
                                    'house-' +
                                    item.latitude +
                                    '-' +
                                    item.longitude
                            }"
                            @mouseenter="!isMobile && itemEnter('house', item)"
                            @mouseleave="itemLeave('house')"
                            @click="isMobile && itemEnter('house', item)"
                        >
                            <a
                                :href="transformLink2WordPress(item.detailLink)"
                                :target="getDetailTarget(item)"
                                rel="noopener noreferrer"
                            >
                                <p class="addr">
                                    {{ item.isShowMask ? $t('addressNotDisclosed') : item.formatAddress }}
                                </p>
                                <p class="desc">
                                    <span class="prop">{{
                                        item.propertyTypeText ||
                                            item.propertyType
                                    }}</span>
                                    <span
                                        v-if="item.commercialRealEstate"
                                        class="detail"
                                    >
                                        <span
                                        >{{
                                            $t('md-map.sqft', {
                                                num: item.isShowMask ? '***' :
                                                    (
                                                        item.sqft > -1
                                                            ? item.sqft
                                                            : '-'
                                                    )
                                            })
                                        }}
                                            |</span
                                        >
                                        <span
                                        >{{ item.lotSizeWithUnit }} |</span
                                        >
                                        <span>{{ item.pricePerSqft }}</span>
                                    </span>
                                    <span v-else class="detail">
                                        <span
                                            class="vertical-line"
                                            v-if="item.bedrooms > 0"
                                        >{{
                                            item.isShowMask ? $t('md-map.bed_one', { num : '***' }) : formatBed(item.bedrooms, 2)
                                        }}</span
                                        >
                                        <span
                                            class="vertical-line"
                                            v-if="item.bathrooms > 0"
                                        >{{
                                            item.isShowMask ? $t('md-map.bath_one', { num : '***' }) : formatBath(item.bathrooms, 2)
                                        }}</span
                                        >
                                        <span class="vertical-line">{{
                                            item.isShowMask ? $t('md-map.sqft', { num : '***' }) : formatSqft(item, 2)
                                        }}</span>
                                    </span>
                                </p>
                                <div class="house-mls-info">
                                    <div class="mls-info">
                                        <p
                                            v-if="
                                                item.mlsOrg.mlsOrgHas74 &&
                                                    item.mlsListingId
                                            "
                                        >
                                            MLS# {{ item.mlsListingId }}
                                        </p>
                                        <div v-if="item.provided && !item.isShowMask" v-html="item.provided"></div>
                                    </div>
                                    <div
                                        v-if="item.mlsLogo"
                                        class="house-mls-info-logo"
                                    >
                                        <site-img
                                            :src="item.mlsLogo"
                                            dir="height"
                                        ></site-img>
                                    </div>
                                </div>
                            </a>
                        </li>
                    </ul>
                    <div v-if="tab.moreLink && !wordPressSSR" class="more">
                        <a :href="tab.moreLink" rel="noopener noreferrer">{{
                            tab.moreLabel || $t('md-map.more')
                        }}</a>
                    </div>
                </template>
                <template v-else-if="tab.type === 'school'">
                    <template
                        v-for="(group, index) in tab.groups"
                        :key="group.label"
                    >
                        <div
                            class="group"
                            :class="{
                                active: schoolGroupActiveIndex === index
                            }"
                            @click="schoolGroupClick(index, group)"
                        >
                            {{ group.label }}
                            {{ group.data && group.data.length }}
                            <i class="iconfont icon-arrow-down"></i>
                        </div>
                        <ul class="list">
                            <li
                                v-for="item in group.data"
                                :key="item.id + '-' + (item.level || '')"
                                class="item server-property"
                                :class="{
                                    active:
                                        itemActiveKey ===
                                        'school-' +
                                        item.latitude +
                                        '-' +
                                        item.longitude
                                }"
                                @mouseenter="
                                    !isMobile && itemEnter('school', item)
                                "
                                @mouseleave="itemLeave('school')"
                                @click="schoolItemClick(item)"
                            >
                                <div
                                    class="score"
                                    :class="[
                                        'score-' + item.gsRating,
                                        {
                                            high: item.gsRating > 9,
                                            middle:
                                                item.gsRating >= 6 &&
                                                item.gsRating <= 9,
                                            low:
                                                !item.gsRating ||
                                                item.gsRating < 6
                                        }
                                    ]"
                                >
                                    {{ item.gsRating || 0 }}
                                </div>
                                <p class="school-name">{{ item.name }}</p>
                                <p class="school-desc">
                                    {{ item.admission }} | {{ item.gradeLow }} -
                                    {{ item.gradeHigh }}
                                </p>
                            </li>
                        </ul>
                    </template>
                </template>
                <template v-else-if="tab.type === 'business'">
                    <template v-for="(group, index) in tab.groups" :key="index">
                        <div
                            class="group"
                            :class="{
                                active: businessGroupActiveIndex === index
                            }"
                            @click="businessGroupClick(index, group)"
                        >
                            {{ group.label }}
                            {{ group.data && group.data.length }}
                            <i class="iconfont icon-arrow-down"></i>
                        </div>
                        <ul class="list">
                            <li
                                v-for="item in group.data"
                                :key="item.id"
                                class="item"
                                :class="{
                                    active:
                                        itemActiveKey ===
                                        'business-' +
                                        item.latitude +
                                        '-' +
                                        item.longitude
                                }"
                                @mouseenter="
                                    !isMobile && itemEnter('business', item)
                                "
                                @mouseleave="itemLeave('business')"
                                @click="isMobile && itemEnter('business', item)"
                            >
                                <p class="name">{{ item.name }}</p>
                                <p class="detail">
                                    <span>{{
                                        item.categoryTertiary ||
                                            item.categorySecondary ||
                                            ''
                                    }}</span>
                                    <span
                                        v-if="
                                            item.categoryTertiary ||
                                                item.categorySecondary
                                        "
                                        class="line"
                                    >|</span
                                    >
                                    <span>{{ $t('md-map.phone') }}</span>
                                    <a
                                        v-if="item.phone"
                                        class="tel"
                                        :href="'tel:' + item.phone"
                                        target="_top"
                                        rel="noopener noreferrer"
                                    >{{ $ft.formatPhone(item.phone) }}</a
                                    >
                                </p>
                            </li>
                        </ul>
                    </template>
                </template>
            </div>
        </div>
        <div class="detail-header" v-show="showDetail">
            <span class="to-back" @click="detailBack">
                <i class="iconfont icon-prev"></i
                >{{ $t('md-map.return') }}</span
            >
        </div>
        <div ref="detailBody" class="detail-body" v-show="showDetail">
            <div class="school" :class="{ 'more-panel': detailData.moreLink }">
                <p class="name">{{ detailData.name }}</p>
                <ul class="table">
                    <li
                        v-for="item in detailData.table"
                        :key="item.label"
                        class="item"
                    >
                        <p class="label">{{ item.label }}</p>
                        <a
                            v-if="item.label === 'Phone'"
                            class="value"
                            :href="'tel:' + item.value"
                            target="_top"
                            rel="noopener noreferrer"
                        >{{ $ft.formatPhone(item.value) }}</a
                        >
                        <p
                            v-else-if="item.label === 'Expenditure'"
                            class="value"
                        >
                            {{ $ft.formatCurrency({ value:item.value, noSpace:true, currencySymbol}) }}
                        </p>
                        <p v-else class="value">{{ item.value }}</p>
                    </li>
                </ul>
                <div v-if="detailData.moreLink && !wordPressSSR" class="more">
                    <a :href="detailData.moreLink" rel="noopener noreferrer">{{
                        detailData.moreLabel ||
                            $t('md-map.viewHomesInThisSchool')
                    }}</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import mapTab from '../map-tab';

export default {
    mixins: [mapTab],
    data: function() {
        return {
            iconMap: {
                school: 'icon-school3',
                house: 'icon-house-fill',
                business: 'icon-show'
            }
        };
    },
    methods: {
        updateDetailData(item) {
            const table = [
                {
                    label: this.$t('md-map.admission'),
                    value: item.admission
                },
                {
                    label: this.$t('md-map.level'),
                    value: `${item.gradeLow}-${item.gradeHigh}`
                }
            ];
            table.push({
                label: this.$t('md-map.address'),
                value: this.$t('md-map.addressStreetCity', {
                    street: item.addressStreet,
                    city: item.addressCity,
                    state: item.addressState,
                    zip: item.addressZip
                })
            });
            if (item.gsRating) {
                table.push({
                    label: this.$t('md-map.rating'),
                    value: item.gsRating
                });
            }
            if (item.phone) {
                table.push({
                    label: this.$t('md-map.phone0'),
                    value: item.phone
                });
            }
            table.push({
                label: this.$t('md-map.library'),
                value: item.library
                    ? this.$t('md-map.yes')
                    : this.$t('md-map.no')
            });
            if (item.expenditure) {
                table.push({
                    label: this.$t('md-map.expenditure'),
                    value: item.expenditure
                });
            }
            if (item.studentTeacherRatio) {
                table.push({
                    label: this.$t('md-map.ratio'),
                    value: this.$t('md-map.studentTeacherRatio', {
                        ratio: item.studentTeacherRatio
                    })
                });
            }
            return {
                name: item.name,
                table
            };
        }
    }
};
</script>

<style lang="scss">
@import '../../../theme/mixin.scss';
@import '../../../theme/media.scss';

.md-map.classic {
    .map-tab {
        flex-shrink: 0;
        height: 100%;
        min-width: 360px;
        width: 0;
        position: relative;
        transition: min-width 0.3s ease;
        box-shadow: -1px 0 3px 0 rgba(0, 0, 0, 0.1);
        .tab-collapse {
            position: absolute;
            left: -22px;
            top: 50%;
            transform: translateY(-50%);
            display: none;
            .icon-more_arrow {
                display: block;
                width: 22px;
                height: 50px;
                background-color: #fff;
                position: absolute;
                margin-top: -33px;
                cursor: pointer;
                &:before {
                    color: #aeaeae;
                    font-size: 12px;
                    font-weight: bold;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                }
            }
        }
        .tab-header {
            width: 100%;
            height: 50px;
            line-height: 50px;
            border-bottom: 1px solid gainsboro;
            display: flex;
            justify-content: space-around;
            overflow: hidden;
            &.single {
                padding-left: 40px;
                justify-content: flex-start;
            }
            .item {
                position: relative;
                color: #939393;
                text-transform: uppercase;
                font-size: 15px;
                cursor: pointer;
                .iconfont {
                    font-size: 15px;
                }
                &.active {
                    color: #000000;
                }

                &.active:after {
                    position: absolute;
                    content: '';
                    display: block;
                    width: 100%;
                    height: 2px;
                    background-color: #000000;
                    left: 0;
                    bottom: 0;
                }
                &.business {
                    display: none;
                }
            }
        }
        .tab-body {
            position: absolute;
            top: 50px;
            bottom: 0;
            width: 100%;
            overflow: hidden;
            .tab-content {
                width: 100%;
                height: 100%;
                overflow: auto;
                .group {
                    line-height: 50px;
                    font-size: 16px;
                    color: #737373;
                    padding-left: 20px;
                    position: relative;
                    cursor: pointer;
                    .icon-arrow-down {
                        position: absolute;
                        right: 20px;
                        &:before {
                            display: block;
                            font-size: 12px;
                            font-weight: bold;
                            transform: scale(0.7);
                        }
                    }
                    + .list {
                        display: none;
                    }
                    &.active {
                        .icon-arrow-down {
                            &:before {
                                transform: rotate(180deg) scale(0.7);
                            }
                        }
                        + .list {
                            display: block;
                        }
                        &:before {
                            border-bottom: none;
                        }
                    }
                }
                .item {
                    position: relative;
                    margin: 4px 0;
                    &:first-child {
                        margin-top: 0;
                        &:before {
                            display: none;
                        }
                    }
                    &:last-child {
                        margin-bottom: 0;
                    }
                    &:hover,
                    &.hover,
                    &.active {
                        background-color: #f1f4f8;
                        &:before,
                        + .item:before {
                            display: none;
                        }
                    }
                }
                &.house {
                    .item {
                        height: auto;
                        padding: 15px 20px 0 20px;
                        cursor: pointer;
                        font-size: 14px;
                        margin: 0;
                        .addr {
                            color: #000000;
                            @include ellipsis();
                            text-decoration: underline;
                        }
                        .desc {
                            margin-top: 10px;
                            color: #191919;
                            display: flex;
                            font-size: 13px;
                            white-space: nowrap;

                            .prop {
                                @include ellipsis();
                                font-size: 13px;
                                color: #fff;
                                border-radius: 5px;
                                margin-right: 7px;
                                padding: 0 4px;
                                display: inline-block;
                                background-color: #c0c7d7;
                            }
                            .vertical-line {
                                &:after {
                                    content: ' |';
                                }
                                &:nth-last-child(1)::after {
                                    content: '';
                                }
                            }
                        }
                        .house-mls-info {
                            width: 100%;
                            display: flex;
                            .mls-info {
                                width: 80%;
                                font-size: 12px;
                                color: var(--color-label);
                                line-height: 14px;
                                margin-top: 10px;
                                display: block;
                            }
                            .house-mls-info-logo {
                                width: 20%;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                img {
                                    max-height: 40%;
                                    max-width: 100%;
                                }
                            }
                        }

                        &:hover {
                            .addr {
                                @include color-theme();
                            }
                        }
                    }
                }
                &.school {
                    .item {
                        height: 65px;
                        padding: 8px 20px 0 20px;
                        cursor: pointer;
                        margin-bottom: 8px;
                        margin-top: 0;

                        &:last-child {
                            margin-bottom: 0;
                        }

                        .score {
                            float: left;
                            width: 50px;
                            height: 50px;
                            border-radius: 50%;
                            line-height: 55px;
                            font-size: 30px;
                            font-family: var(--font-medium);
                            text-align: center;
                            color: #ffffff;
                            margin-right: 12px;
                            &.high {
                                background-color: #49d975;
                            }

                            &.middle {
                                background-color: #77b0fd;
                            }

                            &.low {
                                background-color: #bbcbd7;
                            }
                        }
                        .school-name {
                            font-family: var(--font-medium);
                            font-size: 16px;
                            color: #000000;
                            @include ellipsis();
                        }
                        .school-desc {
                            font-size: 14px;
                            color: #939393;
                        }
                    }
                }
                &.business {
                    .group {
                        color: #282828;
                        &:before {
                            border-bottom: 1px solid var(--color-border);
                        }
                        &:hover {
                            background: #f4f6fb;
                            @include color-theme();
                        }
                    }
                    .item {
                        height: 70px;
                        padding: 13px 20px 0 20px;
                        cursor: pointer;
                        .name {
                            font-family: var(--font-medium);
                            font-size: 16px;
                            color: #282828;
                            @include ellipsis();
                        }
                        .detail {
                            font-size: 14px;
                            color: #a0a0a0;
                            @include ellipsis();
                            .line {
                                margin: 0 10px;
                            }
                            .tel {
                                text-decoration: underline;
                                &:hover {
                                    @include color-theme();
                                }
                            }
                        }
                    }
                }
            }
        }
        .detail-header {
            @include color-theme();
            height: 60px;
            line-height: 60px;
            font-family: var(--font-bold);
            font-size: 16px;
            border-top: 1px solid #e6e6e6;
            border-bottom: 1px solid #e6e6e6;
            overflow: hidden;
            .to-back {
                display: inline-block;
                cursor: pointer;
            }
            .icon-prev {
                width: 24px;
                height: 28px;
                line-height: 24px;
                margin: 8px 2px 8px 10px;
                font-weight: bold;
                display: inline-block;
                vertical-align: middle;
                cursor: pointer;
                position: relative;
                &:before {
                    position: absolute;
                    width: 24px;
                    text-align: center;
                }
            }
        }
        .detail-body {
            position: absolute;
            top: 60px;
            bottom: 0;
            width: 100%;
            border-right: solid 1px #f0f1f5;
            border-bottom: solid 1px #f0f1f5;
            overflow: hidden;
            .school {
                .name {
                    margin: 16px 20px;
                    font-family: var(--font-bold);
                    font-size: 20px;
                    line-height: 1.2;
                }
                .table {
                    margin-bottom: 10px;
                    padding: 5px 10px;
                    font-size: 16px;
                    font-family: var(--font-normal);
                    .item {
                        display: flex;
                        padding: 0 0 16px 10px;
                        cursor: default;
                        .label {
                            flex-shrink: 0;
                            width: 100px;
                            color: #a0a0a0;
                        }
                        .value {
                            flex-grow: 1;
                            color: #282828;
                        }
                    }
                }
            }
        }
        .more-panel {
            padding-bottom: 40px;
            .more {
                position: absolute;
                width: 100%;
                font-size: 13px;
                height: 40px;
                line-height: 40px;
                background: #f4f4f4;
                bottom: 0;
                text-align: center;

                a {
                    @include color-theme();
                }

                &:hover {
                    text-decoration: underline;
                }
            }
        }
        &.show-business {
            .tab-header {
                .item.business {
                    display: inline-block;
                }
            }
        }
        &.collapsed {
            min-width: 0;
            .tab-collapse {
                .icon-more_arrow {
                    &:before {
                        @include color-theme();
                        transform: translate(-50%, -50%) scale(1.2)
                            rotate(180deg);
                    }
                }
            }
        }
        &.show-collapse {
            .tab-collapse {
                display: block;
            }
        }
    }
    @include media-600 {
        .map-tab {
            background-color: #fff;
            width: 100%;
            height: initial;
            user-select: none;
            position: static;
            .tab-collapse {
                display: none;
                .icon-more_arrow {
                    display: none;
                }
            }
            .tab-body {
                position: relative;
                top: initial;
                bottom: initial;
                border: none;
                .tab-content {
                    .item {
                        + .item {
                            &:before {
                                left: 0;
                                right: 0;
                            }
                        }
                    }
                    &.school {
                        .item {
                            .score {
                                margin-right: 20px;
                            }
                        }
                    }
                }
            }
            .detail-body {
                position: relative;
                top: initial;
                bottom: initial;
                border: none;
                .school .more {
                    position: static;
                    height: 30px;
                    line-height: 30px;
                    font-size: 12px;
                }
            }
            .more-panel {
                padding-bottom: 0;
                .more {
                    height: 40px;
                    line-height: 40px;
                    position: relative;
                }
            }
            &.show-collapse {
                position: relative;
                .tab-header,
                .tab-body {
                    display: flex;
                }
                &.collapsed {
                    margin-bottom: 30px;
                    border-bottom: 1px solid gainsboro;
                    .tab-collapse {
                        display: block;
                        left: 50%;
                        top: initial;
                        bottom: -40px;
                        transform: translate(-50%, -50%);
                        @include color-theme();
                        &:before {
                            content: 'More';
                            font-size: 14px;
                        }
                        .icon-more_arrow {
                            display: inline;
                            position: relative;
                            margin-left: 15px;
                            &:before {
                                @include color-theme();
                                transform: translate(-50%, -50%) scale(0.7)
                                    rotate(0deg);
                            }
                        }
                    }
                    .tab-header,
                    .tab-body {
                        display: none;
                    }
                }
            }
        }
    }
}
</style>
